/**
 * Botão base do admin.
 * - Texto padrão preto (CTAs laranja/claros).
 * - Se `classes` trouxer `text-*`, não força text-black (fundos escuros).
 * - Disabled usa opacity — não pinta bg-gray-900 por cima da cor do botão.
 */
const Button = ({
    type = "button",
    click = null,
    classes = "",
    children,
    disabled,
    onMouseDown = () => null,
    title,
}) => {
    const classStr = typeof classes === "string" ? classes : "";
    const hasExplicitTextColor = /\btext-/.test(classStr);
    const tone = hasExplicitTextColor ? "" : "text-black ";

    return (
        <button
            onMouseDown={onMouseDown}
            disabled={disabled}
            className={`${tone}px-2 m-auto block ${classStr} disabled:opacity-50 disabled:cursor-not-allowed`}
            type={type}
            onClick={click}
            title={title}
        >
            {children}
        </button>
    );
};

export default Button;
